import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Dropdown, Avatar, Typography, Space, Button } from 'antd';
import { UserOutlined, LogoutOutlined, MailOutlined, IdcardOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';

const { Text } = Typography;

const UserProfile: React.FC = () => {
  const { user, logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  };

  if (!user) return null;

  const menuItems: MenuProps['items'] = [
    {
      key: 'user-info',
      label: (
        <div className="user-menu-info">
          <Space direction="vertical" size="small">
            <Space>
              <IdcardOutlined />
              <Text strong>{user.name || 'Unknown User'}</Text>
            </Space>
            <Space>
              <MailOutlined />
              <Text type="secondary">{user.email}</Text>
            </Space>
            {user.org_name && (
              <Space>
                <UserOutlined />
                <Text type="secondary">{user.org_name}</Text>
              </Space>
            )}
          </Space>
        </div>
      ),
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: (
        <Button 
          type="text" 
          icon={<LogoutOutlined />} 
          onClick={handleLogout}
          className="logout-menu-item"
          block
        >
          Sign Out
        </Button>
      ),
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      placement="bottomRight"
      arrow
      trigger={['click']}
      overlayClassName="user-profile-dropdown"
    >
      <div className="user-profile-trigger">
        <Space>
          <Avatar
            size={28}
            src={user.picture}
            icon={<UserOutlined />}
            className="user-avatar"
          />
          <Text className="user-name">{user.name || user.email}</Text>
        </Space>
      </div>
    </Dropdown>
  );
};

export default UserProfile;